<template>
	<div class="week">
		<div class="week__header">
			<h1>
				<i class="fas fa-calendar-week"></i>
				Week {{week.week}} ({{new Date(week.date).format('d M -')}} {{new Date(week.end).format('d M')}})
			</h1>
			<Toggle
				class="week__header__toggleView"
				:options="['byDay', 'byPlanning']"
				:labels="['Sort by day', 'Sort by planning']"
				:value="view"
				@change="toggleView">
			</Toggle>
		</div>
		<div class="week__content">
			<ProgressBlocksWeek class="week__blocks" :plannings="plannings"></ProgressBlocksWeek>
			<TasksWeek
				class="week__tasks"
				:plannings="weekPlannings"
				:week="week">
			</TasksWeek>
		</div>
	</div>
</template>

<script>
import TasksWeek from '@/components/TasksWeek.vue'
import PlanningService from '@/services/PlanningService'
import DateService from '@/services/DateService'
import Toggle from '@/components/Toggle'
import ProgressBlocksWeek from '@/components/ProgressBlocksWeek'
require('@/services/DateFormatService.js')
export default {
	data () {
		return {
			week: null
		}
	},
	components: {
		TasksWeek,
		Toggle,
		ProgressBlocksWeek
	},
	methods: {
		getWeekTasks (week, tasks) {
			return PlanningService.getWeekTasks(week, tasks)
		},
		setWeek () {
			// See if week is specified
			if (!this.$route.params.date) this.week = DateService.getWeek(new Date())
			else this.week = DateService.getWeek(new Date(this.$route.params.date))
		},
		toggleView () {
			this.$store.dispatch('toggleWeekView')
		}
	},
	computed: {
		plannings () {
			return this.$store.state.plannings
		},
		tasks () {
			if (!this.plannings) return []
			const component = this
			var tasks = []
			this.plannings.forEach(function (planning) {
				tasks = tasks.concat(component.getWeekTasks(component.week, planning.Tasks))
			})
			return tasks
		},
		view () {
			return this.$store.state.settings.weekView
		},
		weekPlannings () {
			if (!this.plannings) return []
			const component = this
			var weekPlannings = []
			this.plannings.forEach(function (planning) {
				if (component.getWeekTasks(component.week, planning.Tasks).length > 0) weekPlannings.push(planning)
			})
			return weekPlannings
		},
		lastWeek () {
			const week = DateService.getLastWeek(this.week.date)
			return week.date.format('Y-m-d')
		},
		nextWeek () {
			const week = DateService.getNextWeek(this.week.date)
			return week.date.format('Y-m-d')
		}
	},
	watch: {
		'$route' () {
			this.setWeek()
		}
	},
	created () {
		this.setWeek()
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/views/_week.scss';
</style>
